import React, { FC } from 'react';
import { Heading, Text, VStack } from '@chakra-ui/react';
import { Testimonial } from '../components/chakraUIPro/Testimonial';
import Page from '../components/Page';

const OurStoryPage: FC = () => (
  <Page
    seoOptions={{
      title: 'Our story - The Roots of Vitamin Club',
      description:
        'Explore the story behind Vitamin Club, founded by a dedicated team passionate about health. Learn ' +
        'how our journey began with a vision for family wellness.',
      canonical: 'https://vitaminclub.co.za/our-story/'
    }}
  >
    <VStack spacing={6} align='left'>
      <Heading as='h1' id='Vitamin Club - Our story'>
        Vitamin Club - Our story
      </Heading>
      <Text>
        What happens when a tech wizard, statistician and operations expert start complaining about how painful vitamins
        are to manage?
      </Text>

      <Testimonial accentColor='orange.300' name='Joe Someone' title='Professional dad'>
        First there's the overwhelming number of vitamins and supplements – how am I supposed to know what I need to
        take… …you can’t even get started without engaging a dietitian.
      </Testimonial>

      <Testimonial accentColor='orange.300' name='Mary Everybody' title='Self-diagnosed Workaholic'>
        Never mind that, even if you have figured out what you do need to take, you’ve got to buy like 10 bottles to get
        the right combination of vitamins and there’s no guarantee that they’ll be in the correct doses.
      </Testimonial>

      <Testimonial accentColor='orange.300' name='Nelson, the neighbour' title='Pre-school teacher'>
        And those bottles are the worst - they’re impossible to open and you always end up with 10 tablets in your
        hands!
      </Testimonial>

      <Testimonial accentColor='orange.300' name='Veronica' title='Grocery store clerk'>
        Never mind the cost - by the time you’re done, you’ve broken the bank.
      </Testimonial>

      <Testimonial accentColor='orange.300' name='Loyd' title='A family friend'>
        Why can’t this just be simple??? I can’t believe something like this doesn't exist!
      </Testimonial>

      <Text fontWeight='bold' fontSize='xl'>
        So, inspired by the idea that being healthy should be as easy as brushing your teeth, we built Vitamin Club!
      </Text>

      <Text>
        We partnered with dietitians and explored more than 480 unique vitamin requirements to ensure that your age,
        gender, diet, weight and fitness are accounted for.
      </Text>

      <Text>
        We combined our skills to ensure that the statistical match between the vitamin formulation and your unique
        profile was a close as possible. Then we embedded the logic into an easy to use web application and subscription
        platform. And finally, created both functional and attractive packaging and implemented a national logistics
        model to ensure that we can deliver wherever you are.
      </Text>

      <Text fontWeight='bold' fontSize='2xl'>
        Vitamin Club - Personalised health subscriptions delivered to your door!
      </Text>
    </VStack>
  </Page>
);

export default OurStoryPage;
